import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import OverviewSummary from './sections/OverviewSummary'
import OrderValueTrends from './sections/OrderValueTrends/OrderValueTrends'
import SupplierPerformance from './sections/SupplierPerformance'
import TeamSection from './sections/TeamSection'
import { openLoader, closeLoader } from '../../redux_toolkit/Loader'
import {
    fetchOverviewSourcingTrends,
    fetchOverviewOrderValueByMonth,
    fetchOverviewSuppliers,
    fetchBrandMembers
} from '../../services/v3/Dashboard/Dashborad'
import { authUserInfo } from '../../helpers/Util'

// Dashboard "Overview" tab — composed section by section for readability.
const OverviewTab = ({ dateRange }) => {
    const dispatch = useDispatch()
    const [sourcingData, setSourcingData] = useState(null)
    const [orderValues, setOrderValues] = useState(null)
    const [suppliers, setSuppliers] = useState(null)
    const [teamMembers, setTeamMembers] = useState(null)

    useEffect(() => {
        getSourcingTrends()
        getOrderValueByMonth()
        getSuppliers()
        getBrandMembers()
    }, [dateRange?.type, dateRange?.fromDate, dateRange?.toDate])

    const getSourcingTrends = async () => {
        const brandId = authUserInfo()?.brandResponse?.id
        if (!brandId) return
        try {
            dispatch(openLoader())
            const isCustom = dateRange?.type === 'CUSTOM'
            const params = {
                dateRangeType: dateRange?.type || 'ALL_TIME',
                startDate: isCustom ? dateRange?.fromDate : undefined,
                endDate: isCustom ? dateRange?.toDate : undefined
            }
            const data = await fetchOverviewSourcingTrends(brandId, params)
            setSourcingData(data)
        } catch (error) {
            setSourcingData(null)
        } finally {
            dispatch(closeLoader())
        }
    }

    const getOrderValueByMonth = async () => {
        const brandId = authUserInfo()?.brandResponse?.id
        if (!brandId) return
        try {
            dispatch(openLoader())
            const isCustom = dateRange?.type === 'CUSTOM'
            const params = {
                dateRangeType: dateRange?.type || 'ALL_TIME',
                startDate: isCustom ? dateRange?.fromDate : undefined,
                endDate: isCustom ? dateRange?.toDate : undefined
            }
            const data = await fetchOverviewOrderValueByMonth(brandId, params)
            setOrderValues(data?.orderValues ?? [])
        } catch (error) {
            setOrderValues(null)
        } finally {
            dispatch(closeLoader())
        }
    }

    const getSuppliers = async () => {
        const brandId = authUserInfo()?.brandResponse?.id
        if (!brandId) return
        try {
            dispatch(openLoader())
            const isCustom = dateRange?.type === 'CUSTOM'
            const params = {
                dateRangeType: dateRange?.type || 'ALL_TIME',
                startDate: isCustom ? dateRange?.fromDate : undefined,
                endDate: isCustom ? dateRange?.toDate : undefined
            }
            const data = await fetchOverviewSuppliers(brandId, params)
            setSuppliers(data ?? [])
        } catch (error) {
            setSuppliers(null)
        } finally {
            dispatch(closeLoader())
        }
    }

    const getBrandMembers = async () => {
        const brandId = authUserInfo()?.brandResponse?.id
        if (!brandId) return
        try {
            dispatch(openLoader())
            const data = await fetchBrandMembers(brandId)
            setTeamMembers(data)
        } catch (error) {
            setTeamMembers(null)
        } finally {
            dispatch(closeLoader())
        }
    }

    return (
        <div className='overview-tab flex flex-col gap-0'>
            <OverviewSummary dateRange={dateRange} />
            <OrderValueTrends
                categoryData={sourcingData?.categoryOrderValues}
                orderValues={orderValues}
                dateRange={dateRange}
            />
            <SupplierPerformance suppliers={suppliers} />
            <TeamSection teamMembers={teamMembers} />
        </div>
    )
}

export default OverviewTab
